export default __webpack_public_path__ + "static/media/big-stare-pepe.124e93aa.jpeg";